import { Directive, ViewChild } from '@angular/core';
import {
  getValuableObjectInsuranceTypeLabel,
  getValuableObjectTypeLabel,
} from 'src/app/_enums/valuable-object.enum';
import { getBooleanLabel } from 'src/app/_helpers/utils';
import { ValuableObjectsInsuranceMetatadata } from 'src/app/_types/lead.types';

import { PdfViewerModalComponent } from '../../../pdf-viewer-modal/pdf-viewer-modal.component';
import { BaseMetadataComponent } from '../base-metadata.component';

@Directive()
export abstract class ValuableObjectsMetadataComponentAbstract extends BaseMetadataComponent<ValuableObjectsInsuranceMetatadata> {
  getValuableObjectTypeLabel = getValuableObjectTypeLabel;

  getValuableObjectInsuranceTypeLabel = getValuableObjectInsuranceTypeLabel;

  getBooleanLabel = getBooleanLabel;

  @ViewChild('pdfViewer') viewer!: PdfViewerModalComponent;

  viewFile(key: string) {
    this.userAuthService.getPresignedUrl(key).subscribe((res) => {
      if (res.status === 'SUCCESS') {
        this.viewer.pdfFileUrl = res.data.preSignedUrl;
        this.viewer.openModal();
      }
    });
  }
}
